import { FormControlLabel, styled } from '@mui/material';

export const StyledFormControlLabel = styled(FormControlLabel)({
  '& .MuiFormControlLabel-label': {
    fontSize: '0.85rem',
  },
});
